//React
import React from "react";

//UI
import { Input } from "antd";

//CSS
import "./styles/input.css";


const TextArea = (props) => {
  return <Input.TextArea className="custom-input" {...props} />;
};

export default TextArea;
